
































































































import {Component, Mixins, Watch} from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import XForm from "../SimpleForm.vue";
import XButton from "../SimpleButton.vue";
import ButtonWithMessage from "./ButtonWithMessage.vue";
import AppApiMixin from "../mixins/AppApi.vue";
import { signInForm } from "@/assets/scripts/form-fields/main";
import VueRecaptcha from 'vue-recaptcha';
import {mapGetters, mapMutations} from "vuex";
import {store} from "@/store/store";

const { values, attrs, validations, errors } = signInForm;

@Component({
  components: {
    XForm,
    XButton,
    ButtonWithMessage,
    VueRecaptcha
  },
  mixins: [validationMixin],
  computed: {
    ...errors,
    ...mapGetters('appConfig', {
      appConfigDemo: 'demo',
      appConfigLogin: 'login',
      appConfigPassword: 'password',
      appConfigPayments: 'PAYMENTS',
    }),
    ...mapGetters("stackCaptcha", {
      idCaptcha: "idCaptcha",
      valueCaptcha: "valueCaptcha",
      confirmCaptcha: "confirmCaptcha",
    }),
  },
  methods: {
    ...mapMutations("stackCaptcha", {
      setShowCaptcha: "setShowCaptcha",
      setIdCaptcha: "setIdCaptcha",
    }),
  },
  validations,
})
class SignInForm extends Mixins(XForm, AppApiMixin) {
  [x: string]: any;
  values = values;
  allFieldAttrs = attrs;

  showPassword = false;
  useSubmitButtonLoading = false;
  submitError = "";

  siteKey = ''
  recaptchaEnabled = false;

  captcha = false;
  PAYMENTS = false;

  mounted() {
    this.siteKey = process.env.VUE_APP_RECAPTCHA_SITE_KEY || ''
    this.recaptchaEnabled = (process.env.VUE_APP_RECAPTCHA_ENABLED || '') === "true"

    this.PAYMENTS = !!(this.appConfigPayments || false);

    // для демо кабинета
    if (this.appConfigDemo) {
      this.values['username'] = this.appConfigLogin;
      this.values['password'] = this.appConfigPassword;
    }
  }

  public onCaptchaExpired () {
    //@ts-ignore
    if (this.recaptchaEnabled) {
      this.$refs.recaptcha.reset()
    }
  }

  openPasswordRecoveryPage(): void {
    this.redirectToPage("passwordRecovery");
  }

  openSignUpPage(): void {
    this.redirectToPage("signUp");
  }

  public validate() {
    //@ts-ignore
    if (this.recaptchaEnabled) {
      this.$refs.recaptcha.execute()
    } else {
      this.submitForm('')
    }
  }

  @Watch("confirmCaptcha")
  confirmCaptchaChanged(val) {
    if (val && this.valueCaptcha != "") {
      // при подтверждении
      this.submitForm(null, this.idCaptcha, this.valueCaptcha);
    }
  }

  submitForm(recaptchaToken: string, idCaptcha: string|null = null, valueCaptcha: string|null = null) {
    this.submitError = "";
    this.useSubmitButtonLoading = true;

    const { username, password } = this.getValues();

    this.signIn({ username, password, recaptchaToken, valueCaptcha, idCaptcha })
      .catch(async (e) => {
        if (e == "Введите код с картинки") {
          this.captcha = true;
        }
        this.submitError = e;
        //@ts-ignore
        if (this.recaptchaEnabled) {
          await this.$refs.recaptcha.reset()
        }
      })
      .finally(() => {
        this.useSubmitButtonLoading = false;
      });
  }

  get paymentNoAuthEnabled(): boolean {
    return !!(process.env && (process.env.VUE_APP_BANK_NO_AUTH || "") == "true") && this.PAYMENTS;
  }
}

export default SignInForm;
